var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 224,
    viewBox: "0 0 216 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6086_22737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 187,
    height: 204
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6613 137.331L9.7196 112.738L0 211.167L186.207 223.977L166.256 112.738L129.936 142.455L112.031 131.183L95.6613 137.331Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.7167L9.7196 106.077L95.6613 130.67L112.031 126.059L129.936 136.819L169.326 103.515V20.5683L0 26.7167Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6086_22737)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6086_22737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 20,
    width: 194,
    height: 197
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5918 216.672L38.5918 196.672L-0.408203 42.6719L159.092 20.1719L192.092 203.172L70.5918 216.672Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6086_22737)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6086_22737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.608 37.4794L19.0992 52.7369C15.0506 53.2411 12.2894 57.0869 13.1059 61.0842L43.7938 211.317C44.5261 214.903 47.8962 217.319 51.5267 216.862L172.662 201.608C176.682 201.101 179.434 197.298 178.658 193.322L149.343 43.0852C148.639 39.4741 145.259 37.0247 141.608 37.4794Z",
    fill: "url(#paint0_linear_6086_22737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.608 37.4794L19.0992 52.7369C15.0506 53.2411 12.2894 57.0869 13.1059 61.0842L43.7938 211.317C44.5261 214.903 47.8962 217.319 51.5267 216.862L172.662 201.608C176.682 201.101 179.434 197.298 178.658 193.322L149.343 43.0852C148.639 39.4741 145.259 37.0247 141.608 37.4794Z",
    fill: "url(#paint1_linear_6086_22737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.608 37.4794L19.0992 52.7369C15.0506 53.2411 12.2894 57.0869 13.1059 61.0842L43.7938 211.317C44.5261 214.903 47.8962 217.319 51.5267 216.862L172.662 201.608C176.682 201.101 179.434 197.298 178.658 193.322L149.343 43.0852C148.639 39.4741 145.259 37.0247 141.608 37.4794Z",
    stroke: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.878 125.228L153.172 131.883L147.574 132.57L149.646 143.231L142.44 144.116L140.368 133.455L119.286 136.044L118.004 129.447C123.22 119.58 128.104 109.573 133.32 99.7063L141.002 98.7631L146.28 125.915L151.878 125.228ZM136.43 113.194C136.327 112.664 136.077 111.067 135.828 109.469L126.115 128.511L139.097 126.917L136.43 113.194Z",
    fill: "#A2BADD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.184 125.09C118.206 140.639 112.505 148.636 102.976 149.806C93.686 150.947 85.1544 144.698 82.132 129.149C79.0867 113.482 84.8592 105.537 94.1495 104.396C103.678 103.226 112.139 109.424 115.184 125.09ZM106.846 126.114C104.408 113.569 99.8134 110.635 95.466 111.169C91.3569 111.674 88.0309 115.58 90.4694 128.125C92.8965 140.611 97.5391 143.478 101.648 142.974C105.996 142.44 109.274 138.6 106.846 126.114Z",
    fill: "#A2BADD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9192 133.817L83.2129 140.473L77.6149 141.16L79.6871 151.821L72.4812 152.705L70.409 142.045L49.3273 144.633L48.0451 138.037C53.2611 128.17 58.1451 118.163 63.3611 108.296L71.0434 107.353L76.3212 134.505L81.9192 133.817ZM66.4707 121.784C66.3677 121.254 66.1181 119.656 65.8686 118.059L56.1557 137.101L69.1382 135.507L66.4707 121.784Z",
    fill: "#A2BADD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0918 214.172L41.0918 198.172L57.0793 195.081C61.0342 194.317 64.8168 197.039 65.347 201.033L67.0918 214.172Z",
    fill: "#C7D2F6",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6086_22737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.271 2C192.703 2.00006 211.699 16.7746 211.699 35C211.699 53.2254 192.703 67.9999 169.271 68C160.202 68 151.798 65.7852 144.902 62.0156L133.128 68L137.867 57.1914C131.017 51.3307 126.842 43.5445 126.842 35C126.842 16.7746 145.838 2 169.271 2Z",
    fill: "#4C95FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.27 40.1172C165.295 40.9323 165.675 41.7064 166.329 42.2748C166.982 42.8432 167.858 43.1612 168.77 43.1612C169.681 43.1612 170.557 42.8432 171.21 42.2748C171.864 41.7064 172.244 40.9323 172.27 40.1172V20.044C172.244 19.2289 171.864 18.4548 171.21 17.8864C170.557 17.318 169.681 17 168.77 17C167.858 17 166.982 17.318 166.329 17.8864C165.675 18.4548 165.295 19.2289 165.27 20.044V40.1172ZM165.27 48.8687C165.27 50.5909 166.845 52 168.77 52C170.695 52 172.27 50.5909 172.27 48.8687C172.27 47.1464 170.695 45.7373 168.77 45.7373C167.842 45.7406 166.954 46.0716 166.299 46.6581C165.643 47.2446 165.273 48.0392 165.27 48.8687Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6086_22737",
    x: 8.4624,
    y: 32.925,
    width: 174.827,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6086_22737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6086_22737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6086_22737",
    x: 122.842,
    y: 0,
    width: 92.8574,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6086_22737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6086_22737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6086_22737",
    x1: 95.8418,
    y1: 36.6719,
    x2: 95.8418,
    y2: 217.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6086_22737",
    x1: 95.8418,
    y1: 36.6719,
    x2: 95.8418,
    y2: 217.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIllustration);
export default __webpack_public_path__ + "static/media/notFoundIllustration.737f3eadb2ea3b6116c1b8c0fa9deac6.svg";
export { ForwardRef as ReactComponent };